export class EsteiraModelo {
    public id!: number | string | null;
    public ativo!: boolean;
    public nomeEsteira!: string;
  }